import React, { useState, useEffect } from 'react';
import { Modal, Box, Typography } from '@mui/material';
import { CONTACT_US_MESSAGE } from '../constants/Constants';

// Default values: 1 minute initial delay, and then 3 times longer after each dismissal.
const InactivityHelpModal = ({
  initialDelay = 60000,     // in milliseconds (60,000 ms = 1 minute)
  multiplier = 3,
  resetTrigger,             // parent should update this prop on user action to reset the timer
  contactInfo = CONTACT_US_MESSAGE
}) => {
  const [showModal, setShowModal] = useState(false);
  const [delay, setDelay] = useState(initialDelay);

  useEffect(() => {
    // Reset the modal and timer whenever resetTrigger changes.
    // (e.g. when the parent signals that the user took some action)
    setShowModal(false);

    const timer = setTimeout(() => {
      setShowModal(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [resetTrigger, delay, initialDelay]);

  const handleDismiss = () => {
    setShowModal(false);
    // Increase the delay for the next modal appearance by the given multiplier.
    setDelay(delay * multiplier);
  };

  return (
    <Modal open={showModal} onClose={handleDismiss}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 300,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" component="h2">
          Need Help?
        </Typography>
        <Typography sx={{ mt: 2 }}>
          {contactInfo}
        </Typography>
        <button
            onClick={handleDismiss}
            className="btn btn-primary text-white font-bold rounded-md mt-2"
            style={{padding: "0px 50px"}}
        >
            Dismiss
        </button>

      </Box>
    </Modal>
  );
};

export default InactivityHelpModal;
